import Cookies from "js-cookie";
import { $config } from "../conf";

Cookies.defaults.domain = $config.cookie.domain;

Cookies.globalUserId = (globalUserId, options) => {
  if (globalUserId !== undefined) {
    Cookies.set("globalUserId", JSON.stringify(globalUserId), options);
  } else {
    let data = Cookies.get("globalUserId");
    if (data && data[0] === '"') {
      data = JSON.parse(data);
    }
    return data;
  }
};
Cookies.smarketMember = (schemaId = $config.schemaId, memberInfo, options) => {
  if (memberInfo !== undefined) {
    Cookies.set(`smarketMember_${schemaId}`, memberInfo, options);
  } else {
    let data = Cookies.get(`smarketMember_${schemaId}`);
    if (typeof data == "string") {
      data = JSON.parse(data);
    }
    return data;
  }
};
Cookies.session = (tenantId, session, options) => {
  if (session !== undefined) {
    Cookies.set(`session_${tenantId}`, session, options);
  } else {
    return Cookies.get(`session_${tenantId}`);
  }
};
Cookies.openId = (weChatId, openId, options) => {
  if (openId !== undefined) {
    Cookies.set(`openId_${weChatId}`, openId, options);
  } else {
    return Cookies.get(`openId_${weChatId}`);
  }
};
Cookies.unionId = (unionId, options) => {
  if (unionId !== undefined) {
    Cookies.set("unionId", unionId, options);
  } else {
    return Cookies.get("unionId");
  }
};

export let $cookies = Cookies;
export let COOKIE = {
  install(Vue) {
    Vue.prototype.$cookies = $cookies;
  },
};
